import styled from '@emotion/styled';
import themeGet from '@styled-system/theme-get';
import Card from '../Card';

export const StyledDependableSendingBlock = styled.article`
  background: #FAFBFF;
  display: flex;
  flex-wrap: wrap;
  padding: 2rem 24px;

  .dependable-block--text {
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;

    .dependable-block--inner{
      @media (min-width: 481px) {
        width: 82%;
      }

      h2 {
        margin-bottom: 24px;
        font-weight: 600;
        font-size: 34px;
      }

      h3 {
        color: #2C4A7D;
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 0.5rem;
      }

      p {
        margin-bottom: 1rem;
      }
    }
  }

  .dependable-block--image {
    width: calc(100%/3);
    margin: 4rem auto 0;
  }

  .dependable-block--stats-wrapper{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    margin: 6rem 0 0;
    text-align: center;

    .dependable-block--stat {
      width: 100%;

      h2 {
        font-size: 28pt;
        color: #22D5A7;
        margin-bottom: 0;
        font-weight: 700;
        letter-spacing: 2.3px;
      }

      p {
        font-size: 14px;
        color: #00634A;
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: 2.3px;

        a {
          color: #00634A;
        }
      }
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-top: 0;
    padding: 140px 11rem;

    .dependable-block--text {
      text-align: left;
      width: calc(100%/3*2);
    }
  
    .dependable-block--image {
      margin-top: 0;
      width: calc(100%/3);
    }

    .dependable-block--stats-wrapper{
      text-align: left;

      .dependable-block--stat{
        width: auto;

        h2 {
          font-size: 38pt;
        }
      }
    }
  }
`;

export const StyledCards = styled.div`
  display: grid;
  grid-row-gap: ${themeGet('scale.scaleBase')};

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: ${themeGet('scale.scaleUp05')};
    grid-row-gap: ${themeGet('scale.scaleUp07')};
  }
`;

export const StyledCard = styled(Card)`
  .resource-card__image-container{
    height: 30%;
    overflow: hidden;

    .gatsby-image-wrapper{
      height:100%;
    }
  }

  .resource-dot {
    height: 25px;
    width: 25px;
    background-color: green;
    border-radius: 50%;
    display: inline-block;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {

  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {

  }
`;